import * as actionTypes from '../constants/actionTypes';
export function downloadAssets(_a) {
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType;
    return {
        type: actionTypes.DOWNLOAD_ASSETS,
        screenID: screenID,
        elementID: elementID,
        assetType: assetType,
    };
}
export function downloadAssetsStart(_a) {
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType, requestID = _a.requestID;
    return {
        type: actionTypes.DOWNLOAD_ASSETS_START,
        screenID: screenID,
        elementID: elementID,
        assetType: assetType,
        requestID: requestID,
    };
}
export function assetsZipCreated(url, _a) {
    var elementID = _a.elementID, assetType = _a.assetType, requestID = _a.requestID;
    return {
        type: actionTypes.ASSETS_ZIP_CREATED,
        elementID: elementID,
        assetType: assetType,
        requestID: requestID,
        url: url,
    };
}
export function assetsZipDownloaded(_a) {
    var elementID = _a.elementID, assetType = _a.assetType, requestID = _a.requestID;
    return {
        type: actionTypes.ASSETS_ZIP_DOWNLOADED,
        elementID: elementID,
        assetType: assetType,
        requestID: requestID,
    };
}
